module.exports = __webpack_public_path__ + "img/ylb-14.9b817cb1.png";